const carouselData = [
  {
    id: 1,
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20entertainment%20news%20editorial%20scene%20with%20warm%20red%20and%20black%20abstract%20shapes%2C%20suggesting%20celebrity%20scandal%20breaking%20news%2C%20cinematic%20dramatic%20lighting%20with%20deep%20shadows%2C%20magazine%20cover%20aesthetic%2C%20bold%20visual%20composition%2C%20no%20text%2C%20no%20faces%2C%20editorial%20photography&width=800&height=500&seq=carousel-01-51cg&orientation=landscape',
    tag: '娱乐',
    title: '某顶流男星深夜密会神秘女子，酒店同住三天细节曝光',
    excerpt: '据知情人透露，两人已秘密交往半年之久，此次被拍实属巧合。多方信源交叉验证，事件真实性极高。',
    heat: '980w',
  },
  {
    id: 2,
    image: 'https://readdy.ai/api/search-image?query=Dark%20mysterious%20editorial%20composition%20with%20amber%20and%20crimson%20gradients%2C%20abstract%20geometric%20patterns%20suggesting%20gossip%20and%20entertainment%20industry%20secrets%2C%20dramatic%20contrast%20lighting%2C%20luxurious%20atmosphere%2C%20editorial%20style%2C%20no%20text%2C%20no%20people&width=800&height=500&seq=carousel-02-51cg&orientation=landscape',
    tag: '综艺',
    title: '热门综艺录制现场突发意外，当红嘉宾当场罢录引发全网热议',
    excerpt: '节目组紧急叫停录制，相关画面已被全部删除。事件起因疑似合同纠纷升级，多方说法不一。',
    heat: '756w',
  },
  {
    id: 3,
    image: 'https://readdy.ai/api/search-image?query=Warm%20toned%20abstract%20editorial%20image%20with%20red%20and%20dark%20contrast%2C%20suggesting%20social%20media%20drama%20and%20internet%20celebrity%20news%2C%20soft%20textured%20background%20with%20digital%20elements%2C%20cinematic%20feel%2C%20no%20text%2C%20no%20faces%2C%20editorial%20photography&width=800&height=500&seq=carousel-03-51cg&orientation=landscape',
    tag: '网红',
    title: '千万粉丝网红被爆虚假人设，聊天记录流出引粉丝大规模脱粉',
    excerpt: '多条实锤证据在社交平台疯传，品牌方已陆续解除合作。当事人至今未作出正面回应。',
    heat: '689w',
  },
  {
    id: 4,
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20editorial%20composition%20with%20deep%20red%20and%20black%20abstract%20shapes%2C%20evoking%20music%20industry%20scandal%20and%20entertainment%20drama%2C%20bold%20visual%20impact%20with%20warm%20accents%2C%20magazine%20aesthetic%2C%20no%20text%2C%20no%20people%2C%20editorial%20photography&width=800&height=500&seq=carousel-04-51cg&orientation=landscape',
    tag: '音乐',
    title: '知名歌手新专辑疑似抄袭海外小众作品，乐评人列出详细对比',
    excerpt: '八首歌中有五首被指与海外独立音乐人作品高度雷同，乐迷社区已炸开了锅。',
    heat: '543w',
  },
  {
    id: 5,
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20editorial%20image%20with%20warm%20crimson%20and%20dark%20tones%2C%20abstract%20composition%20suggesting%20film%20and%20TV%20industry%20behind%20the%20scenes%20drama%2C%20dramatic%20lighting%20with%20soft%20textures%2C%20editorial%20style%2C%20no%20text%2C%20no%20faces&width=800&height=500&seq=carousel-05-51cg&orientation=landscape',
    tag: '影视',
    title: '电影剧组内部矛盾激化，导演与主演片场对骂视频外流',
    excerpt: '长达三分钟的对骂录音被工作人员泄露，制片方已报警处理。影片上映档期或受影响。',
    heat: '487w',
  },
  {
    id: 6,
    image: 'https://readdy.ai/api/search-image?query=Abstract%20editorial%20composition%20with%20warm%20dark%20red%20gradients%2C%20suggesting%20exclusive%20scoop%20and%20breaking%20entertainment%20news%2C%20bold%20geometric%20elements%2C%20cinematic%20dramatic%20lighting%2C%20magazine%20style%2C%20no%20text%2C%20no%20people&width=800&height=500&seq=carousel-06-51cg&orientation=landscape',
    tag: '独家',
    title: '某知名夫妻档被曝已分居半年，财产分割方案初步敲定',
    excerpt: '圈内人士独家爆料，两人对外依旧维持恩爱形象，实则各自已有新欢。离婚声明或于下月发布。',
    heat: '1256w',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            吃瓜前线
          </h2>
          <p className="mt-2 text-sm text-foreground-500">热点黑料一网打尽，最新八卦抢先看</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {carouselData.map((item) => (
            <article
              key={item.id}
              className="group bg-background-50 border border-background-200/60 rounded-lg overflow-hidden cursor-pointer hover:border-primary-200/60 transition-colors"
            >
              <div className="relative w-full" style={{ aspectRatio: '16/10' }}>
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top"
                />
                <span className="absolute top-3 left-3 text-xs font-medium bg-primary-500 text-background-50 px-2 py-0.5 rounded whitespace-nowrap">
                  {item.tag}
                </span>
                <span className="absolute top-3 right-3 text-xs text-background-50 bg-black/40 px-2 py-0.5 rounded whitespace-nowrap">
                  <i className="ri-fire-line mr-1"></i>{item.heat}
                </span>
              </div>
              <div className="p-4">
                <h3 className="text-base font-heading font-bold text-foreground-950 leading-snug mb-2 line-clamp-2 group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2">
                  {item.excerpt}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}